import { IBlackFriday } from '../types/blackFriday';

export const DEFAULT_BLACK_FRIDAY_SETTINGS: IBlackFriday = { isActive: false, url: '' };
